module.exports = __webpack_public_path__ + "static/bg-hq-319fd17e157f1be6dc5ca62b21943c73.png";